/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 PRO React examples
import PageLayout from 'examples/LayoutContainers/PageLayout';

function BasicLayout({ image, children }) {
  return (
    <PageLayout>
      {/* Fullscreen video background */}
      <MDBox
        component='video'
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0
        }}
      >
        <source src='/video.webm' type='video/webm' />
      </MDBox>

      {/* Dark overlay */}
      <MDBox
        position='fixed'
        top={0}
        left={0}
        width='100%'
        height='100%'
        sx={{
          zIndex: 1,
          background:
            'linear-gradient(135deg, rgba(10,14,26,0.82) 0%, rgba(17,24,39,0.75) 40%, rgba(26,16,37,0.80) 100%)',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              'radial-gradient(ellipse at 20% 50%, rgba(226,0,27,0.08) 0%, transparent 50%), ' +
              'radial-gradient(ellipse at 80% 20%, rgba(90,163,255,0.06) 0%, transparent 50%)',
            pointerEvents: 'none'
          }
        }}
      />

      <MDBox px={1} width='100%' height='100vh' mx='auto' position='relative' zIndex={2}>
        <Grid container spacing={1} justifyContent='center' alignItems='center' height='100%'>
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node.isRequired
};

BasicLayout.defaultProps = {
  image: ''
};

export default BasicLayout;
